import React from 'react';
import PageLayout from '../../componentsV2/PageLayout/PageLayout';
import Button from '../../componentsV2/Button/Button';

const EmailVerificationAlreadyConfirmedPage = () => {
  return (
    <PageLayout
      pageTitle="Account activated"
      shouldShowPageHeader
      shouldShowBreadcrumbs={false}
    >
      <div className="my-4 pl-2">
        <p className="mb-4 text-vamos-dark">
          Your Vamos account has been activated.
        </p>

        <p className="mb-6 text-vamos-dark">
          Please log in.
        </p>

        <Button
          label="Go to Login"
          onClick={() => { window.location.href = '/users/sign_in'; }}
          color="action"
          size="lg"
          dataTestId="email-verification-go-login-button"
        />
      </div>
    </PageLayout>
  );
};

export default EmailVerificationAlreadyConfirmedPage;
